import { formatIsoDate } from '@front-activerse/common-components';
import { RedirectRoute } from '../Routing/types';

const redirects: RedirectRoute[] = [
  {
    path: '/tracker',
    redirectTo: `/tracker/${formatIsoDate(new Date())}`,
  },
];

export default redirects;
